var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypeleftDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15.538 9.172-5.157 5.156h3.95a.5.5 0 1 1 0 1H9.174a.5.5 0 0 1-.5-.5V9.672a.5.5 0 0 1 1 0v3.95l5.157-5.157a.5.5 0 1 1 .707.707Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.933 19.071c-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142-3.905 3.906-10.237 3.906-14.142 0Zm13.435-.707A9 9 0 1 1 5.64 5.636a9 9 0 0 1 12.728 12.728Z",
  fill: "currentColor"
})));
export { SvgTypeleftDown as ReactComponent };
export default __webpack_public_path__ + "5f1aad064c684ef751ddfb3ab9c5aa56.svg";